/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import {
	HcpSummaryFragmentDoc,
	HcpAffiliationLinkFragmentDoc
} from '../../../../core/fragments/Hcp/HCP.hook';
import { HcoSummaryFragmentDoc } from '../../../../core/fragments/Hco/HCOSummary.hook';
import {
	HcpSearchAndFiltersFragmentDoc,
	HcoSearchAndFiltersFragmentDoc
} from '../../../../core/fragments/core.hook';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRecentHistoryQueryVariables = Types.Exact<{
	paginationInput: Types.PaginationInput;
	entityTypes: Array<Types.EntityType> | Types.EntityType;
}>;

export type GetRecentHistoryQuery = {
	__typename?: 'Query';
	recentProfiles:
		| { __typename?: 'BadRequest' }
		| {
				__typename?: 'ProfileVisitResults';
				results: Array<{
					__typename?: 'ProfileVisit';
					lastVisit: any;
					profile:
						| {
								__typename?: 'HCO';
								vid_V: string;
								veevaid_V: string;
								statusCda_V?: string | null;
								statusCda_VId?: string | null;
								hcoNameCda_V?: string | null;
								displayName_V?: string | null;
								hcoNameShort_V?: string | null;
								hcoNameEnglish_V?: string | null;
								hcoNameIntl_V?: string | null;
								hcoTypeCda_V?: string | null;
								addresses: Array<{
									__typename?: 'Address';
									vid_V: string;
									primaryCda_V?: boolean | null;
									cityCda_V?: string | null;
									cityIntl_V?: string | null;
									stateCda_V?: string | null;
									countryCda_V?: string | null;
									streetAddress1Cda_V?: string | null;
									streetAddress1Intl_V?: string | null;
									postalCodeCda_V?: string | null;
									postalCodeIntl_V?: string | null;
								}>;
								hcoType?: {
									__typename?: 'HCOType';
									id: string;
									name: string;
								} | null;
						  }
						| {
								__typename?: 'HCP';
								vid_V: string;
								veevaid_V: string;
								statusCda_V?: string | null;
								statusCda_VId?: string | null;
								firstNameCda_V?: string | null;
								firstNameIntl_V?: string | null;
								middleNameCda_V?: string | null;
								middleNameIntl_V?: string | null;
								lastNameCda_V?: string | null;
								lastNameIntl_V?: string | null;
								nickname_V?: string | null;
								prefixCda_V?: string | null;
								suffixCda_V?: string | null;
								allDegreeCda_V?: string | null;
								degree1Cda_V?: string | null;
								hcpTypeCda_V?: string | null;
								hcpType?: {
									__typename?: 'HCPType';
									id: string;
									name: string;
									count: number;
								} | null;
								hcpSpecialties: Array<{
									__typename?: 'HCPSpecialty';
									primary: boolean;
									specialty: {
										__typename?: 'Specialty';
										id: string;
										name: string;
										specialtyGroup: {
											__typename?: 'SpecialtyGroup';
											id: string;
											name: string;
										};
									};
								}>;
								addresses: Array<{
									__typename?: 'Address';
									vid_V: string;
									primaryCda_V?: boolean | null;
									cityCda_V?: string | null;
									cityIntl_V?: string | null;
									stateCda_V?: string | null;
									countryCda_V?: string | null;
									streetAddress1Cda_V?: string | null;
									streetAddress1Intl_V?: string | null;
									postalCodeCda_V?: string | null;
									postalCodeIntl_V?: string | null;
								}>;
								affiliationSearch:
									| { __typename?: 'BadRequest' }
									| {
											__typename?: 'HCPAffiliationsResults';
											results: Array<{
												__typename?: 'ParentHCO';
												vid_V: string;
												classOfWork_V?: string | null;
												isPrimaryRelationship_V?: boolean | null;
												parentHcoStatus_VId?: string | null;
												childVeevaid_V?: string | null;
												parentVeevaid_V?: string | null;
												jobTitle_V?: string | null;
												parentHco:
													| {
															__typename?: 'HCO';
															officePhoneCda_V?: string | null;
															vid_V: string;
															veevaid_V: string;
															statusCda_V?: string | null;
															statusCda_VId?: string | null;
															hcoNameCda_V?: string | null;
															displayName_V?: string | null;
															hcoNameShort_V?: string | null;
															hcoNameEnglish_V?: string | null;
															hcoNameIntl_V?: string | null;
															hcoTypeCda_V?: string | null;
															addresses: Array<{
																__typename?: 'Address';
																streetAddress1Cda_V?: string | null;
																streetAddress1Intl_V?: string | null;
																streetAddress2Cda_V?: string | null;
																streetAddress2Intl_V?: string | null;
																postalCodeCda_V?: string | null;
																postalCodeIntl_V?: string | null;
																postalCodeFullUs_V?: string | null;
																cbsa_V?: string | null;
																latitudeCda_V?: number | null;
																longitudeCda_V?: number | null;
																statusCda_V?: string | null;
																statusCda_VId?: string | null;
																subStateAdminUnit_V?: string | null;
																businessCda_V?: boolean | null;
																dpvConfirmedIndicator_V?: string | null;
																buildingIdentifier_V?: string | null;
																phoneCda_V?: string | null;
																faxCda_V?: string | null;
																vid_V: string;
																primaryCda_V?: boolean | null;
																cityCda_V?: string | null;
																cityIntl_V?: string | null;
																stateCda_V?: string | null;
																countryCda_V?: string | null;
																hospitalCampus?:
																	| {
																			__typename?: 'HCO';
																			vid_V: string;
																			veevaid_V: string;
																			statusCda_V?: string | null;
																			statusCda_VId?: string | null;
																			hcoNameCda_V?: string | null;
																			displayName_V?: string | null;
																			hcoNameShort_V?: string | null;
																			hcoNameEnglish_V?: string | null;
																			hcoNameIntl_V?: string | null;
																			hcoTypeCda_V?: string | null;
																			addresses: Array<{
																				__typename?: 'Address';
																				vid_V: string;
																				primaryCda_V?: boolean | null;
																				cityCda_V?: string | null;
																				cityIntl_V?: string | null;
																				stateCda_V?: string | null;
																				countryCda_V?: string | null;
																				streetAddress1Cda_V?: string | null;
																				streetAddress1Intl_V?: string | null;
																				postalCodeCda_V?: string | null;
																				postalCodeIntl_V?: string | null;
																			}>;
																			hcoType?: {
																				__typename?: 'HCOType';
																				id: string;
																				name: string;
																			} | null;
																	  }
																	| {
																			__typename?: 'ResourceNotFound';
																			message: string;
																	  }
																	| null;
															}>;
															hcoType?: {
																__typename?: 'HCOType';
																id: string;
																name: string;
															} | null;
													  }
													| {
															__typename?: 'ResourceNotFound';
															message: string;
													  };
												relationshipType?: {
													__typename?: 'RelationshipType';
													code: string;
													name: string;
												} | null;
											}>;
									  };
						  }
						| { __typename?: 'ResourceNotFound' };
				}>;
		  };
	recentSearches:
		| { __typename?: 'BadRequest' }
		| {
				__typename?: 'RecentSearchResults';
				results: Array<{
					__typename?: 'RecentSearch';
					searchKey: string;
					entityType: Types.EntityType;
					lastSearch: any;
					payload:
						| {
								__typename?: 'HCOSearchAndFiltersType';
								searchString?: string | null;
								countries?: Array<string> | null;
								states?: Array<string> | null;
								hcoTypes?: Array<string> | null;
								includeInactive: boolean;
						  }
						| {
								__typename?: 'HCPSearchAndFiltersType';
								searchString?: string | null;
								countries?: Array<string> | null;
								states?: Array<string> | null;
								specialtyGroups?: Array<string> | null;
								specialties?: Array<string> | null;
								hcpTypes?: Array<string> | null;
								hcos?: Array<string> | null;
								includeInactive: boolean;
						  };
				}>;
		  };
};

export const GetRecentHistoryDocument = gql`
	query GetRecentHistory(
		$paginationInput: PaginationInput!
		$entityTypes: [EntityType!]!
	) {
		recentProfiles(
			paginationInput: $paginationInput
			entityTypes: $entityTypes
		) {
			... on ProfileVisitResults {
				results {
					lastVisit
					profile {
						...HCPSummary
						...HCPAffiliationLink
						...HCOSummary
					}
				}
			}
		}
		recentSearches(
			paginationInput: $paginationInput
			entityTypes: $entityTypes
		) {
			... on RecentSearchResults {
				results {
					searchKey
					entityType
					lastSearch
					payload {
						...HCPSearchAndFilters
						...HCOSearchAndFilters
					}
				}
			}
		}
	}
	${HcpSummaryFragmentDoc}
	${HcpAffiliationLinkFragmentDoc}
	${HcoSummaryFragmentDoc}
	${HcpSearchAndFiltersFragmentDoc}
	${HcoSearchAndFiltersFragmentDoc}
`;

/**
 * __useGetRecentHistoryQuery__
 *
 * To run a query within a React component, call `useGetRecentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentHistoryQuery({
 *   variables: {
 *      paginationInput: // value for 'paginationInput'
 *      entityTypes: // value for 'entityTypes'
 *   },
 * });
 */
export function useGetRecentHistoryQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetRecentHistoryQuery,
		GetRecentHistoryQueryVariables
	> &
		(
			| { variables: GetRecentHistoryQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetRecentHistoryQuery, GetRecentHistoryQueryVariables>(
		GetRecentHistoryDocument,
		options
	);
}
export function useGetRecentHistoryLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetRecentHistoryQuery,
		GetRecentHistoryQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetRecentHistoryQuery,
		GetRecentHistoryQueryVariables
	>(GetRecentHistoryDocument, options);
}
export function useGetRecentHistorySuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetRecentHistoryQuery,
				GetRecentHistoryQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetRecentHistoryQuery,
		GetRecentHistoryQueryVariables
	>(GetRecentHistoryDocument, options);
}
export type GetRecentHistoryQueryHookResult = ReturnType<
	typeof useGetRecentHistoryQuery
>;
export type GetRecentHistoryLazyQueryHookResult = ReturnType<
	typeof useGetRecentHistoryLazyQuery
>;
export type GetRecentHistorySuspenseQueryHookResult = ReturnType<
	typeof useGetRecentHistorySuspenseQuery
>;
export type GetRecentHistoryQueryResult = Apollo.QueryResult<
	GetRecentHistoryQuery,
	GetRecentHistoryQueryVariables
>;
